export default __webpack_public_path__ + "static/media/jane-churchyard-screengrab-8.514b3eb7.jpg";